import { render, staticRenderFns } from "./ItemFilterDetectionLayout.vue?vue&type=template&id=06dd59d1&scoped=true&"
import script from "./ItemFilterDetectionLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterDetectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd59d1",
  null
  
)

export default component.exports